import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { CommonService } from 'src/app/shared/utils/common.service';

@Component({
  selector: 'app-floor-access-point',
  templateUrl: './floor-access-point.component.html',
  styleUrls: ['./floor-access-point.component.scss'],
})
export class FloorAccessPointComponent implements OnInit, OnDestroy {
  @Input() name!: string;
  @Input() accessPointStatus!: string;
  @Input() accessPointId!: string;
  @Input() floorId!: string;
  @Input() floorName!: string;
  selected: boolean = false;
  subscription: Subscription | undefined;
  sharedData: any;

  constructor(
    private sharedDataService: SharedDataService,
    private commonService: CommonService
  ) {}

  /**
   * @description: runs on when component is initialized. This method subscribes loginservice.
   * @input {none}
   * @output {void}
   */

  ngOnInit(): void {
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
      }
    );
  }

  /**
   * @description: This method set the selected unit id and name to the shared-data-service
   * @input { unitId , unitName }
   * @output { none }
   */
  unitClickHandler(
    accessPointId: string,
    accessPointName: string,
    floorId: string,
    floorName: string
  ) {
    if (this.sharedData.selectedAccessPoint.accessPointId === accessPointId) {
      return;
    }
    this.sharedDataService.setSelectedUnit({
      unitId: '',
      unitName: '',
    });

    this.sharedDataService.setSelectedFloor({
      floorId: floorId,
      floorName: floorName,
    });

    this.sharedDataService.setSelectedAccessPoint({
      accessPointId: accessPointId,
      accessPointName: accessPointName,
    });
  }

  /**
   * @description: runs just before component unmount. Unsubscribes the login service
   * @input {none}
   * @output {void}
   */

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
